import $ from "jquery";
import axios from "axios";

(function () {
    const filter = {
        init: function () {
            const _self = this,
                form = $('.js-filter'),
                orderBy_filters = $('.js-orderBy-filters');
            if (!form.length) {
                return;
            }
            let timeout;
            $('body').on('change keyup', '.js-filter input, .js-filter select', function (e) {
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(function () {
                    const url = form.attr('action') + '?' + form.serialize();
                    _self.buildFields(orderBy_filters, form.serializeObject().filter);
                    axios.get(url)
                        .then(function (response) {
                            $('#items').html(response.data.items);
                            $('#pagination').replaceWith(response.data.pagination);
                            history.pushState({}, '', url)
                        });
                }, 500);
            });
        },
        buildFields: function (cont, filters) {
            cont.html('');
            for (let key in filters) {
                if (typeof filters[key] === 'object') {
                    for (let sub_key in filters[key]) {
                        if (filters[key][sub_key] !== '') {
                            cont.append(
                                $('<input/>', {
                                    name: `filter[${key}][${sub_key}]`,
                                    type: 'hidden',
                                    value: filters[key][sub_key]
                                })
                            );
                        }
                    }
                } else {
                    if (filters[key] !== '') {
                        cont.append(
                            $('<input/>', {name: `filter[${key}]`, type: 'hidden', value: filters[key]})
                        );
                    }
                }
            }
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/filter.js